// extracted by mini-css-extract-plugin
module.exports =  {"y-axis":"AnimatingAvatar-b6FS__y-axis","yAxis":"AnimatingAvatar-kI_u__yAxis","x-axis":"AnimatingAvatar-M8a2__x-axis","xAxis":"AnimatingAvatar-nTvl__xAxis"};